<template>
  <div id="otp-notice" class="message"/>
  <div id="otp-container">
    <div id="channel-select">
      <div id="send-options" v-if="smsNum !== ''">
        <p> {{ strings['SelectText'] }} </p>
        <div class="send-opt">
          <input type="radio" id="sms" name="send-method" value="SMS">
          <label for="sms"> {{ smsStr }} </label>
        </div>
        <div class="send-opt" v-if="emailAdd !== ''">
          <input type="radio" id="email" name="send-method" value="Email">
          <label for="email" id="email-label"> {{ emailStr }} </label>
        </div>
      </div>
      <a id="back-opt" @click="$emit('back')">← {{ strings['Back'] }}</a>
      <input type="button" :value="buttonText" id="send-button"
             class="button button-primary button-large" @click="sendOTP">
      <br class="clearField">
    </div>
    <otp-entry
        v-if="sent"
        :strings = strings
        @otpAccepted="otpAccepted"
        @otpRejected="otpRejected"
    />
    <otp-reset
        v-if="showReset"
        :strings = strings
        :otp = otp
        @back="$emit('back')"
        @notice="showNotice"
    />
  </div>
</template>

<script setup>
import $ from 'jquery';
import {toRef, ref, computed, onMounted} from "vue";
import OtpReset from "./otpReset";
import OtpEntry from "./otpEntry"

const emit = defineEmits(['back']);
const props = defineProps(["strings", "smsNum", "emailAdd"]);
const strings = props['strings'];

let smsNum = toRef(props,'smsNum');
let emailAdd = toRef(props, 'emailAdd');

let sent = ref(false);
let showReset = ref(false);
let buttonTimer = ref();
let otp = ref('');

let smsStr = computed(() => {
  return strings['SMS'] + ': ' + smsNum.value;
});
let emailStr = computed(() => {
  return strings['Email'] + ': ' + emailAdd.value;
});
let buttonText = computed(() => {
  if (sent.value === false) {
    return strings['SendButton'];
  } else {
    if (buttonTimer.value === 0 ) {
      return strings['SendAgain'];
    }
    return strings['SendAgain'] + " " + buttonTimer.value;
  }
});

onMounted(function() {
  // add notice to top of screen
  $('h1').after($('#otp-notice'));

  if (smsNum.value === '') {
    // channels were not offered, send via OTP via email
    sendOTP();
  }
});

function sendOTP() {
  // if no sms is available, the channel is always Email
  let channel;
  if (smsNum.value !== '') {
    channel = $('input[name="send-method"]:checked');
    if (channel.length === 0) return false;
    channel = channel.val();
  } else {
    channel = 'Email';
  }

  $(document.body).css({'cursor' : 'wait'});
  $('#send-button').prop("disabled", true);

  $.post(strings['AjaxUrl'], {
    action: 'send-otp',
    usernameOrEmail: $('#user_login').val(),
    channel: channel
  }, function(res) {
    if (res === "1") {
      sent.value = true;
      alterSendButtonTimer(30);
      showNotice(strings[channel + 'Success'], 'message')
    } else {
      $('#send-button').prop("disabled", false);
      showNotice(strings['SendFailure'], 'error');
    }

    $(document.body).css({'cursor' : 'default'});
  });
}

function showNotice(message, type) {
  let notice = $('#otp-notice');
  notice.fadeIn();
  // change to appropriate class
  if (type === 'message') {
    notice.removeClass('otp-error');
    notice.addClass('otp-message');
  } else {
    notice.removeClass('otp-message');
    notice.addClass('otp-error');
  }
  notice.html(message);
}

function alterSendButtonTimer(sec) {
  let button = $('#send-button');
  button.prop("disabled", true);
  buttonTimer.value = sec;
  let counter = setInterval(function() {
    if (buttonTimer.value === 0) {
      clearInterval(counter);
      button.prop("disabled", false);
    } else {
      buttonTimer.value--;
    }
  }, 1000);
}

function otpAccepted(givenOtp) {
  otp.value = givenOtp;
  $('#otp-notice').fadeOut();
  $('#otp-entry').fadeOut();
  $('#channel-select').fadeOut().promise().done(function() {
    showReset.value = true;
  });
}

function otpRejected() {
  showNotice(strings['InvalidOtp'], 'error');
  alterSendButtonTimer(0);
}
</script>

<style scoped>
#otp-notice {
  display: none;
}

.otp-error {
  background-color: #F66 !important;
}

#send-options {
  margin-bottom: 15px;
}

.send-opt {
  margin: 10px;
  word-break: break-all;
}

#email-label {
  display: contents;
}

#back-opt {
  float: left;
  margin-top: 7px;
}
</style>